import { useState } from "react";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { SelectOption } from "@iddataweb/idw-common-ui/types";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { resources } from "@constants/hardcoded-strings";
import { DefaultModal } from "@containers/common/modals/default-modal/default-modal";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { SelectFormGroup } from "@containers/common/select-form-group/select-form-group";

type AddMessageTemplateLanguageModalProps = {
    availableLanguages: Array<SelectOption<LocaleTypes>>;
    onModalClose: () => void;
    onClickContinue: (localeType: LocaleTypes) => void;
};

export const AddMessageTemplateLanguageModal = (props: AddMessageTemplateLanguageModalProps) => {
    const {
        availableLanguages,
        onModalClose,
        onClickContinue
    } = props;

    const [selectedLocaleType, setSelectedLocaleType] = useState(availableLanguages[0]);

    const onChangeLocaleType = (newOption: SelectOption<LocaleTypes>) => {
        setSelectedLocaleType(newOption);
    };

    const onClickSave = () => {
        onClickContinue(selectedLocaleType.value);
        onModalClose();
    };

    return (
        <DefaultModal
            automationId="add-landing-page-modal"
            ariaLabelledBy="add-landing-page-title"
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
        >
            <Modal.Header id={"add-landing-page-title"} closeButton>
                <Modal.Title>{resources.modals.addMessageTemplateLanguage.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SelectFormGroup
                    automationId={`add-message-template-language-select`}
                    controlId={`add-message-template-language-select`}
                    ariaLabel={resources.modals.addMessageTemplateLanguage.inputs.language.label}
                    label={resources.modals.addMessageTemplateLanguage.inputs.language.label}
                    disabled={false}
                    isClearable={false}
                    isRequired={true}
                    isSearchable={true}
                    onChange={onChangeLocaleType}
                    options={availableLanguages}
                    selectedOption={selectedLocaleType}
                    labelWidth={LabelWidthTypes.MEDIUM}
                    layout={LayoutTypes.ROW}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button id="add-message-template-language-cancel-button" variant="secondary" onClick={onModalClose}>
                    {resources.common.buttons.cancel.label}
                </Button>
                <Button
                    id="add-message-template-language-submit-button"
                    variant="primary"
                    onClick={onClickSave}
                    disabled={false}
                >
                    {resources.common.buttons.save.label}
                </Button>
            </Modal.Footer>
        </DefaultModal>
    );
};